<template>
    <div class="grid grid-cols-2 gap-4">
        <DesignLabOptionsCard
            v-for="option in options"
            :key="option.value"
            :show-error="error"
            :selected="option.value === selected"
            :option-data="option"
            @select-option="optionSelected"
        />
    </div>
</template>
<script setup lang="ts">
import type { OptionsCardType } from '#shared/types/design-lab/OptionsCardType';
import DesignLabOptionsCard from '~/components/design-lab/components/drawers/components/DesignLabOptionsCard.vue';

withDefaults(
    defineProps<{
        error?: boolean;
        selected?: number | null;
        options: OptionsCardType[] | null;
    }>(),
    {
        error: false,
        selected: null,
        options: null,
    },
);

const emit = defineEmits<{
    (e: 'selectOption', value: number): void;
}>();

function optionSelected(value: number) {
    emit('selectOption', value);
}
</script>
